import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import { isPhoneNumberValid } from '../helpers/is-phone-number-valid.function';

export class CustomValidators {
  static passwordConfirm(passwordControl: AbstractControl): ValidatorFn {
    return (passwordConfirmControl: AbstractControl): ValidationErrors | null => {
      if (passwordConfirmControl.value !== passwordControl.value) {
        return { mismatch: true };
      }

      return null;
    };
  }

  static phoneNumber(phoneControl: AbstractControl): ValidationErrors | null {
    const value: string = phoneControl.value.trim();

    if (!isPhoneNumberValid(value)) {
      return { error: true };
    }

    return null;
  }

  static forbiddenEmail(emailControl: AbstractControl): ValidationErrors | null {
    const value: string = emailControl.value.trim();

    if (value.endsWith('@mail.ru')) {
      return { forbiddenEmail: true };
    }

    return null;
  }
}
